import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService, PrimeNGConfig } from 'primeng/api';
import { ContasReceberModel } from '../models/contas-receber-model';
import { EmpresaModel } from '../models/empresa-model';
import { Funcoes, Periodos } from '../services/funcoes';
import { Services } from '../services/servicos';
import { FinanceiroModel } from './financeiro-model';

@Component({
  selector: 'app-financeiro',
  templateUrl: './financeiro.component.html',
  styleUrls: ['./financeiro.component.css']
})
export class FinanceiroComponent implements OnInit {

  //DECLARAÇÕES
  funcoes: Funcoes = new Funcoes();
  //
  //INI VARIÁVES
  empresas: EmpresaModel[];
  selecionarEmpresa: EmpresaModel;

  origens: any[];
  selecionarOrigem: any;

  periodos: Periodos[];
  selecionarPeriodo: string;

  data_inicial: Date = new Date();
  data_final: Date = new Date();
  grafico: any;
  grafico_bar: any;

  lista: FinanceiroModel[];
  currentUser = JSON.parse(localStorage.getItem('currentUser'));
  total: number
  loading: boolean = true;
  selectedList: FinanceiroModel;
  filtros: FinanceiroModel = new FinanceiroModel();

  //RENDIMENTOS
  listaGeral: ContasReceberModel[];
  listaRendimentos: ContasReceberModel[];
  totalRendimentos: number
  displayRendimentos: boolean;
  //TITULOS VENCIDOS
  listaTitulosVencidos: ContasReceberModel[];
  totalTitulosVencidos: number
  displayTitulosVencidos: boolean;
  //TITULOS A VENCER
  listaTitulosVencer: ContasReceberModel[];
  totalTitulosVencer: number
  displayTitulosVencer: boolean;
  //TITULOS RECEBIDOS APOS VENCIMENTO
  listaRecebidoAposVencimento: ContasReceberModel[];
  totalRecebidoAposVencimento: number
  displayRecebidoAposVencimento: boolean;
  //TITULOS RECEBIDOS ATE VENCIMENTO
  listaRecebidosAteVencimento: ContasReceberModel[];
  totalRecebidosAteVencimento: number
  displayRecebidosAteVencimento: boolean;
  //D-PG(TRANFERENCIA PAGO DENTRO DO MES)
  listaRecebidosPG: ContasReceberModel[];
  totalRecebidosPG: number
  displayRecebidosPG: boolean;
  //E-RECEBIDO ATÉ DO VENCIMENTO(sim SÓ BOLETO)
  listaRecebidosAteVencimentoBoleto: ContasReceberModel[];
  totalRecebidosAteVencimentoBoleto: number
  displayRecebidosAteVencimentoBoleto: boolean;
  //F-BX(INADIPLENCIA FORA DO MES EM FORMA DE TRANFERENCIA)
  listaRecebidosBX: ContasReceberModel[];
  totalRecebidosBX: number
  displayRecebidosBX: boolean;
  //G-INAD(INADIPLENCIA FORA DO MES EM FORMA DE BOLETO)
  listaRecebidosInad: ContasReceberModel[];
  totalRecebidosInad: number
  displayRecebidosInad: boolean;

  //FIM VARIÁVEIS

  constructor(private service: Services,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private config: PrimeNGConfig) {

    this.periodos = this.funcoes.Periodos;
    if (this.periodos.length > 0) {
      this.selecionaMesAtual();
    }
    this.origens = this.funcoes.Origens;
  }

  selecionaMesAtual() {
    var today = new Date();
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    this.selecionarPeriodo = this.periodos.find(c => c.cod == mm).nome;
    console.log(this.selecionarPeriodo);
    this.selecionaPeriodo(this.selecionarPeriodo);
  }

  ngOnInit(): void {

    this.config.setTranslation({
      accept: 'Aceitar',
      reject: 'Cancelar',
      dayNames: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
      dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
      dayNamesMin: ["Do", "Se", "Te", "Qu", "Qu", "Se", "Sa"],
      monthNames: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
      monthNamesShort: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
      today: 'Hoje',
      clear: 'Limpar'
      //translations
    });

    //BUSCANDO EMPRESAS
    try {
      this.service.listarEmpresas()
        .subscribe(data => {
          if (data.Success) {
            this.empresas = data.Response;
          }
        },
          err => console.error(err)
        );
    }
    catch (e) {
      alert(e);
    }
    //BUSCANDO EMPRESAS     
    this.selecionaMesAtual();
    //PESQUISANDO AO ABRIR
    this.pesquisar();
  }


  pesquisar() {
    this.loading = true;

    this.filtros.filtro_data_inicial = this.data_inicial;
    this.filtros.filtro_data_final = this.data_final;
    this.filtros.origem = this.selecionarOrigem == undefined ? "Receber" : this.selecionarOrigem.nome;
    this.filtros.coligada = this.selecionarEmpresa == null ? "" : this.selecionarEmpresa.nome_fantasia;
    // console.log(this.filtros);
    // console.log(this.selecionarOrigem == undefined ? "Receber" : this.selecionarOrigem.nome);
    // console.log(this.selecionarEmpresa == null ? "" : this.selecionarEmpresa.nome_fantasia);
    try {
      this.service.listarFinanceiro(this.filtros)
        .subscribe(data => {
          if (data.Success) {
            this.lista = data.Response;
            this.total = this.lista.length;
            this.loading = false;
            if (this.filtros.origem == "Receber") {
              this.updateChart(data.Response);
            }else{
              this.updateChartPagar(data.Response);
            }
          }
        },
          err => console.error(err)
        );
    }
    catch (e) {
      alert(e);
    }
  }

  onRowSelect(event) {

    try {
      this.service.listarFinanceiroOrigem(this.filtros)
        .subscribe(data => {
          if (data.Success) {
            this.listaGeral = data.Response;
            if (this.filtros.origem == "Receber") {
              // if (event.data.origem == "B - Rendimentos") {
              //   this.displayRendimentos = true;
              //   this.listaRendimentos = this.listaGeral.filter(element => element.origem == "vencimento" && element.tipo_pagamento == "Rendimento");
              //   this.totalRendimentos = this.listaRendimentos.length;
              // }
              if (event.data.origem == "B - Títulos Vencidos") {
                this.displayTitulosVencidos = true;
                this.listaTitulosVencidos = this.listaGeral.filter(c => c.origem == "vencimento" && c.status == "NÃO");
                this.totalTitulosVencidos = this.listaTitulosVencidos.length;
              }
              else if (event.data.origem == "C - Títulos a Vencer") {
                console.log(this.listaGeral);
                this.displayTitulosVencer = true;
                this.listaTitulosVencer = this.listaGeral.filter(c => c.origem == "vencimento" && this.comparandoDatasTitulosVencer(c.vencimento) && c.status == "NÃO");
                console.log(this.listaTitulosVencer);
                this.totalTitulosVencer = this.listaTitulosVencer.length;
              }
               else if (event.data.origem == "D - PG(Transferência pago dentro do mês)") {
                this.displayRecebidosPG = true;
                this.listaRecebidosPG = this.listaGeral.filter(c => c.origem == "pagamento" && c.data_pagamento > c.vencimento && c.status == "SIM");
                this.totalRecebidosPG = this.listaRecebidosPG.length;
              }
              else if (event.data.origem == "E - Pago até a data de vencimento (SÓ BOLETO)") {
                this.displayRecebidosAteVencimentoBoleto = true;
                this.listaRecebidosAteVencimentoBoleto = this.listaGeral.filter(c => c.origem == "pagamento" && c.data_pagamento <= c.vencimento && c.status == "SIM");
                this.totalRecebidosAteVencimentoBoleto = this.listaRecebidosAteVencimentoBoleto.length;
              }
              else if (event.data.origem == "F - BX(Inadiplência fora do mês em forma de transferência)") {
                this.displayRecebidosBX = true;
                this.listaRecebidosBX = this.listaGeral.filter(c => c.origem == "pagamento" && c.data_pagamento > c.vencimento && c.status == "SIM");
                this.totalRecebidosBX = this.listaRecebidosBX.length;
              }
              else if (event.data.origem == "G - INAD(Inadiplência fora do mês em forma de boleto)") {
                this.displayRecebidosInad = true;
                this.listaRecebidosInad = this.listaGeral.filter(c => c.origem == "pagamento" && c.data_pagamento <= c.vencimento && c.conta_contabil == "INAD");
                this.totalRecebidosInad = this.listaRecebidosInad.length;
              }
            }else{
               if (event.data.origem == "B - Títulos Vencidos") {
                this.displayTitulosVencidos = true;
                this.listaTitulosVencidos = this.listaGeral.filter(c => c.origem == "vencimento" && c.status == "NÃO");
                this.totalTitulosVencidos = this.listaTitulosVencidos.length;
              }
              else if (event.data.origem == "C - Títulos a Vencer") {
                console.log(this.listaGeral);
                this.displayTitulosVencer = true;
                this.listaTitulosVencer = this.listaGeral.filter(c => c.origem == "vencimento" && this.comparandoDatasTitulosVencer(c.vencimento) && c.status == "NÃO");
                console.log(this.listaTitulosVencer);
                this.totalTitulosVencer = this.listaTitulosVencer.length;
              }
              else if (event.data.origem == "D - PG(Transferência pago dentro do mês)") {
                this.displayRecebidosPG = true;
                this.listaRecebidosPG = this.listaGeral.filter(c => c.origem == "pagamento" && c.data_pagamento > c.vencimento && c.status == "SIM");
                this.totalRecebidosPG = this.listaRecebidosPG.length;
              }
              else if (event.data.origem == "E - Pago até a data de vencimento (SÓ BOLETO)") {
                this.displayRecebidosAteVencimentoBoleto = true;
                this.listaRecebidosAteVencimentoBoleto = this.listaGeral.filter(c => c.origem == "pagamento" && c.data_pagamento <= c.vencimento && c.status == "SIM");
                this.totalRecebidosAteVencimentoBoleto = this.listaRecebidosAteVencimentoBoleto.length;
              }
              else if (event.data.origem == "F - BX(Inadiplência fora do mês em forma de transferência)") {
                this.displayRecebidosBX = true;
                this.listaRecebidosBX = this.listaGeral.filter(c => c.origem == "pagamento" && c.data_pagamento > c.vencimento && c.status == "SIM");
                this.totalRecebidosBX = this.listaRecebidosBX.length;
              }
              else if (event.data.origem == "G - INAD(Inadiplência fora do mês em forma de boleto)") {
                this.displayRecebidosInad = true;
                this.listaRecebidosInad = this.listaGeral.filter(c => c.origem == "pagamento" && c.data_pagamento <= c.vencimento && c.status == "SIM");
                this.totalRecebidosInad = this.listaRecebidosInad.length;
              }
            }
          }
        },
          err => console.error(err)
        );
    }
    catch (e) {
      alert(e);
    }
  }

  comparandoDatasTitulosVencer(vencimento: Date) {
    var today = new Date();
    var DataVencimento = new Date(vencimento);
    // console.log(vencimento);
    // var dd = String(vencimento).padStart(2, '0');
    // var mm = String(vencimento).padStart(2, '0'); //January is 0!
    // var yyyy = vencimento;
    // console.log(dd);

    // const DataVencimento = new Date(Number(yyyy),Number(mm),Number(dd));
    console.log(DataVencimento);
    console.log(today);

    return (DataVencimento > today);
  }

  updateChart(chart: FinanceiroModel[]) {

    this.grafico = {
      labels: [
        'B - Títulos Vencidos',
        'C - Títulos a Vencer',
        'D - PG',
        'E - Pago até a data de vencimento (SÓ BOLETO)',
        'F - BX',
        'G - INAD'],
      datasets: [
        {
          data: [chart[1].valor_chart, chart[2].valor_chart, chart[3].valor_chart, chart[4].valor_chart, chart[5].valor_chart, chart[6].valor_chart],
          backgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56",
            "#40c764",
            "#b32525",
            "#575F2C",
            "#A64DC4"
          ],
          hoverBackgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56",
            "#40c764",
            "#b32525",
            "#575F2C",
            "#A64DC4"
          ]
        }]
    };


    this.grafico_bar = {
      datasets: [{
        data: [
          chart[1].valor_chart, chart[2].valor_chart, chart[3].valor_chart, chart[4].valor_chart, chart[5].valor_chart, chart[6].valor_chart
        ],
        backgroundColor: [
          "#FF6384",
          "#36A2EB",
          "#FFCE56",
          "#40c764",
          "#b32525",
          "#575F2C",
          "#A64DC4"
        ],
        label: 'Gráfico'
      }],
      labels: [
        'B - Títulos Vencidos',
        'C - Títulos a Vencer',
        'D - PG',
        'E - Pago até a data de vencimento (SÓ BOLETO)',
        'F - BX',
        'G - INAD'
      ]
    }

  }


  updateChartPagar(chart: FinanceiroModel[]) {
    
    this.grafico = {
      labels: [
        'B - Títulos Vencidos',
        'C - Títulos a Vencer',
        'D - PG',
        'E - Pago até a data de vencimento (SÓ BOLETO)',
        'F - BX',
        'G - INAD'],
      datasets: [
        {
          data: [chart[1].valor_chart, chart[2].valor_chart, chart[3].valor_chart, chart[4].valor_chart],
          backgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56",
            "#40c764",
          ],
          hoverBackgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56",
            "#40c764",
          ]
        }]
    };
  }

  onChangePeriodo(event) {
    if (event.value != null) {
      this.selecionaPeriodo(event.value);
      console.log(event);
    }
  }

  selecionaPeriodo(mes: string) {
    console.log('LOKOOOOO' + mes);
    if (mes == "Todos") {
      this.data_inicial = new Date(1950, 1, 1);
      this.data_final = new Date();
    }
    else if (mes == "3 Meses") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), today.getMonth() + 1, (today.getDay() - 111));
      this.data_final = new Date();
      console.log((today.getDay() - 90));
      console.log(today);
      console.log(this.data_inicial);
    }
    else if (mes == "6 Meses") {

      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), today.getMonth() + 1, (today.getDay() - 201));
      this.data_final = new Date();
      console.log((today.getDay() - 180));
      console.log(today);
      console.log(this.data_inicial);
    }
    else if (mes == "9 Meses") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), today.getMonth() + 1, (today.getDay() - 291));
      this.data_final = new Date();
      console.log((today.getDay() - 270));
      console.log(today);
      console.log(this.data_inicial);
    }
    else if (mes == "1 Ano") {

      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), today.getMonth() + 1, (today.getDay() - 386));
      this.data_final = new Date();
      console.log((today.getDay() - 365));
      console.log(today);
      console.log(this.data_inicial);
    }
    else if (mes == "Janeiro") {

      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 0, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Fevereiro") {

      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 1, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Março") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 2, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Abril") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 3, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Maio") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 4, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Junho") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 5, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Julho") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 6, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Agosto") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 7, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Setembro") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 8, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Outubro") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 9, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Novembro") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 10, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
    else if (mes == "Dezembro") {
      var today = new Date();
      this.data_inicial = new Date(today.getFullYear(), 11, 1);
      var ultimoDia = new Date(this.data_inicial.getFullYear(), this.data_inicial.getMonth() + 1, 0);
      this.data_final = ultimoDia;
      console.log(ultimoDia.getDate());
    }
  }

}
